module.exports = __webpack_public_path__ + "img/product-shansuan-zsyy-01.9504d6aa.png";